import { render } from "./pos-settings.vue?vue&type=template&id=677b8991"
import script from "./pos-settings.vue?vue&type=script&lang=js"
export * from "./pos-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__